// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader__3qv_p","load8":"Spinner__load8__3MmNW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 116
// module chunks = 3